import { Controller } from "@hotwired/stimulus"

const COOKIE_NAME = "chk_theme"
const DEFAULT_THEME = "doppler"
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365 // 1 year

function setCookie(name, value) {
  document.cookie = `${name}=${value}; max-age=${COOKIE_MAX_AGE}; path=/; SameSite=Lax`
}

export default class extends Controller {
  static targets = ["option", "form", "input"]

  optionTargetConnected(element) {
    const current = document.documentElement.dataset.theme || DEFAULT_THEME
    element.dataset.active = element.dataset.theme === current ? "true" : "false"
  }

  select(event) {
    const theme = event.currentTarget.dataset.theme
    if (!theme) return

    setCookie(COOKIE_NAME, theme)
    document.documentElement.dataset.theme = theme
    this.markActive()
    this.persist(theme)
  }

  persist(theme) {
    if (!this.hasFormTarget) return
    this.inputTarget.value = theme
    this.formTarget.requestSubmit()
  }

  markActive() {
    const current = document.documentElement.dataset.theme || DEFAULT_THEME
    this.optionTargets.forEach((el) => {
      el.dataset.active = el.dataset.theme === current ? "true" : "false"
    })
  }
}
